import React from "react";
import InsideHeader from "../../../components/InsideHeader";
import { useSelector } from "react-redux";
import { Descriptions } from "antd";
import { cashConverter, dateForHumans, numberWithCommas } from "../../../utils";

function AssetTransferDetails() {
  const { folderObj } = useSelector((state) => state.folder);
  const items = [
    
    {
      key: "1",
      label: "Comments",
      children: folderObj?.atComments,
    },

    {
      key: "1",
      label: "Asset Code",
      children: folderObj?.atAssetCode,
    },
 
    {
      key: "5",
      label: "Created Date",
      children: <div>{dateForHumans(folderObj?.atCreatedDate)}</div>,
    },
    
  ];
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Asset Transfer information"
        subtitle="Manage Asset Transfer within your institution"
        back={true}
        title1="Asset Transfer"
        title2="Asset Transfer details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={{ xs: 1, sm: 2 }}
              colon={false}
              title="Asset Transfer Information"
              items={items}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssetTransferDetails;
